(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  function observeAll() {
    document.querySelectorAll('.mirae-reveal:not(.is-visible)').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeAll);
  } else {
    observeAll();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () {
      setTimeout(observeAll, 100);
    });
  }
})();

/* Main-image prev/next arrows. They drive Dawn's own thumbnail activation
   (clicking a thumbnail button calls media-gallery.setActiveMedia), so the
   main image, thumbnail highlight and slider scroll all stay in sync. */
(function () {
  function bind(nav) {
    if (nav.dataset.miraeBound) return;
    var gallery = nav.closest('media-gallery');
    if (!gallery) return;
    var thumbs = gallery.querySelector('[id^="Slider-Thumbnails"]');
    if (!thumbs) return;
    nav.dataset.miraeBound = '1';

    function items() {
      return [].slice.call(thumbs.querySelectorAll('.thumbnail-list__item'));
    }
    function go(dir) {
      var list = items();
      if (!list.length) return;
      var i = -1;
      for (var k = 0; k < list.length; k++) {
        var b = list[k].querySelector('button');
        if (b && b.getAttribute('aria-current') === 'true') { i = k; break; }
      }
      if (i < 0) i = 0;
      var n = (i + dir + list.length) % list.length;
      var btn = list[n].querySelector('button');
      if (btn) btn.click();
    }

    var prev = nav.querySelector('[data-mirae-gallery-prev]');
    var next = nav.querySelector('[data-mirae-gallery-next]');
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
  }

  function init(root) {
    (root || document).querySelectorAll('.mirae-gallery-nav').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  }
})();

/* Bundle row picker: selects variant, syncs price + add-to-cart label, proxies to Dawn */
class MiraeBundlePicker extends HTMLElement {
  connectedCallback() {
    this.cards = this.querySelectorAll('.mirae-bundle__card');
    this.sectionId = this.dataset.section;
    this.variantSelects = document.getElementById('variant-selects-' + this.sectionId);
    this.section = document.getElementById('MainProduct-' + this.sectionId);
    this.priceEl = document.getElementById('price-' + this.sectionId);

    this.cards.forEach(function (card) {
      card.addEventListener('click', this.onCardClick.bind(this));
    }.bind(this));

    /* Default selection: if the shopper hasn't picked a variant via the URL,
       select the highlighted default card (the hero) so its real price/total is used. */
    var hasUrlVariant = false;
    try {
      hasUrlVariant = !!new URLSearchParams(window.location.search).get('variant');
    } catch (e) {}

    if (!hasUrlVariant) {
      var target =
        this.querySelector('.mirae-bundle__card[data-default="true"]') ||
        this.querySelector('.mirae-bundle__card.is-selected');
      if (target) this.selectCard(target);
    } else {
      this.updateAtcButton();
    }
  }

  selectCard(card) {
    if (!card) return;
    var variantId = card.dataset.variantId;
    var optionValue = card.dataset.optionValue;

    this.cards.forEach(function (c) { c.classList.remove('is-selected'); });
    card.classList.add('is-selected');

    this.updatePriceDisplay(card.dataset.variantPrice);
    this.updateAtcButton();

    /* Match the hidden Dawn radio by option value so Dawn updates price, URL and
       the form's variant id input. Looked up live on every click: Dawn replaces
       the variant-selects node after a change, so a cached reference goes stale
       and the sticky bar would keep showing the previous variant's price. */
    var variantSelects = document.getElementById('variant-selects-' + this.sectionId);
    if (variantSelects) {
      var radios = variantSelects.querySelectorAll('input[type="radio"]');
      radios.forEach(function (radio) {
        if (radio.value === optionValue && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    /* Immediate sync so a fast add-to-cart uses the right variant. */
    if (this.section) {
      this.section.querySelectorAll('input.product-variant-id').forEach(function (input) {
        input.value = variantId;
        input.removeAttribute('disabled');
      });
    }
  }

  onCardClick(event) {
    this.selectCard(event.currentTarget);
  }

  /* Instantly reflect the selected variant's price (no dependency on Dawn's async fetch). */
  updatePriceDisplay(money) {
    if (!this.priceEl || !money) return;
    this.priceEl.querySelectorAll('.price-item--regular, .price-item--sale').forEach(function (item) {
      if (item.tagName !== 'S') item.textContent = money;
    });
  }

  /* Keep the add-to-cart label as the calm spec CTA "In winkelwagen" (uppercased by CSS).
     No floating price. This also normalises Dawn's locale label, which is not Dutch by default. */
  updateAtcButton() {
    if (!this.section) return;
    var btn = this.section.querySelector('.product-form__submit');
    if (!btn || btn.hasAttribute('disabled')) return;
    var span = btn.querySelector('span');
    if (span) span.textContent = 'In winkelwagen';
  }
}

if (!customElements.get('mirae-bundle-picker')) {
  customElements.define('mirae-bundle-picker', MiraeBundlePicker);
}

/* Keep the add-to-cart label in sync after Dawn re-renders the buy button on variant change. */
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
  subscribe(PUB_SUB_EVENTS.variantChange, function () {
    setTimeout(function () {
      document.querySelectorAll('mirae-bundle-picker').forEach(function (picker) {
        if (typeof picker.updateAtcButton === 'function') picker.updateAtcButton();
      });
    }, 0);
  });
}
